/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatpresetfacebookpost3Inputs */

const en_formatpresetfacebookpost3 = /** @type {(inputs: Formatpresetfacebookpost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook Post`)
};

const de_formatpresetfacebookpost3 = /** @type {(inputs: Formatpresetfacebookpost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook-Beitrag`)
};

/**
* | output |
* | --- |
* | "Facebook Post" |
*
* @param {Formatpresetfacebookpost3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatpresetfacebookpost3 = /** @type {((inputs?: Formatpresetfacebookpost3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatpresetfacebookpost3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatpresetfacebookpost3(inputs)
	return de_formatpresetfacebookpost3(inputs)
});
export { formatpresetfacebookpost3 as "formatPresetFacebookPost" }